(function () {
    'use strict';

    angular.module('core')
        .controller('OptionsController', optionsController);

    optionsController.$inject = ['$rootScope', '$scope', 'tableConfigService', 'dataConfigService', 'ArcGISMap'];

    function optionsController($rootScope, $scope, tableConfigService, dataConfigService, ArcGISMap) {
        $scope.dataConfig = dataConfigService.config;
        $scope.tableConfig = tableConfigService;

        $scope.redrawTable = function () {
            $rootScope.$broadcast('redrawTable');
        };

        $scope.arcMap = ArcGISMap;
        $scope.layersVisibility = {
            'Georeferencinis pagrindas': { visible: true, inverse: 'Ortofoto pagrindas' },
            'Ortofoto pagrindas': { visible: false, inverse: 'Georeferencinis pagrindas' },
            'Kelių priežiūros objektai': { visible: true, inverse: null }
        };

        $scope.toggleLayer = function (layerName, stop) {
            var layer = $scope.arcMap.get().getLayer(layerName);
            if (!layer)
                return;
            if (layer.visible && !$scope.layersVisibility[layerName].visible) {
                layer.hide();
            } else if ($scope.layersVisibility[layerName].visible) {
                layer.show();
            }

            if ($scope.layersVisibility[layerName].inverse != null && !stop) {
                var inv = $scope.layersVisibility[layerName].inverse;
                $scope.layersVisibility[inv].visible = !$scope.layersVisibility[layerName].visible;
                $scope.toggleLayer(inv, true);
            }
        };

        $scope.saveColumns = function() {
            dataConfigService.setColumnsToCookie();
        }
    }

})();
